import PropTypes from 'prop-types';
import { faLocationDot, faCopyright, faGlobe, faSquareCheck } from '@fortawesome/free-solid-svg-icons';
import { useTranslation } from 'react-i18next';
import { useNavigate } from "react-router-dom";
import getLogo from '../../utils/getLogo';
import React, { useEffect, useState } from 'react';
import { getCountryName } from '../../utils/countries';
import Card from '../common/Card';
import useFavorites from '../../hooks/useFavorites';
import { useDispatch } from 'react-redux';
import { favoritesAddExhibitor, favoritesDelExhibitor } from '../../store/favoritesSlice';

const ExhibitorItem = ({ exhibitor }) => {
	const { i18n } = useTranslation();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const inFav = useFavorites({ type: 'exhibitor', object: exhibitor });
    const lang = i18n.language;
    const icon = getLogo(exhibitor);
    const [ cats, setCats ] = useState(''); // отображаем только основные категории
    const [ cont, setCont ] = useState(''); // контакты

    useEffect(() => {
        let cats = [];
        for(let i = 0; i < exhibitor.categories.length; i ++) {
            const cat = exhibitor.categories[i];
            if(cat.type === 'main' && !cat.is_folder) {
                cats.push(cat.name[lang]);
            }
        }
        setCats(cats.sort().join(', '));

        if(exhibitor.contacts) {
            setCont(`${getCountryName(exhibitor.contacts.country, lang)}, ${exhibitor.contacts.city[lang]}`);
        }

        exhibitor.stickers.sort((a, b) => a.priority - b.priority);
    }, [ exhibitor, lang ]);

    const onClick = () => {
        navigate(`../exhibitor/${exhibitor._id}`);
    };

    const onFavClick = () => {
        if(inFav) {
            dispatch(favoritesDelExhibitor(exhibitor));
        } else {
            dispatch(favoritesAddExhibitor(exhibitor));
        }
    };

	return (
        <Card
            name={exhibitor.name[lang]}
            descr={exhibitor.brief[lang]}
            icon={icon}
            inFav={inFav}
            isHigh={exhibitor.highlight?.length > 0}
            onClick={onClick}
            onFavClick={onFavClick}
            stickers={exhibitor.stickers}
            items={[{
                icon: faGlobe,
                text: cont,
            },{
                icon: faLocationDot,
                text: exhibitor.stand,
            },{
                icon: faCopyright,
                text: exhibitor.brand,
            },{
                icon: faSquareCheck,
                text: cats,
            }]}
        />
    );
};

ExhibitorItem.propTypes = {
    exhibitor: PropTypes.object.isRequired,
};

export default ExhibitorItem;
